import type { Decoration, TextNodeStyle } from './../../../../../ricos-schema/legacy/wix/rich_content/v1';
import { Decoration_Type } from './../../../../../ricos-schema/legacy/wix/rich_content/v1';

const convertDocumentStyleDecorationTypes = (decorations: Decoration[]) => {
  let draftBlockStyles = {};
  decorations.forEach(decoration => {
    decoration &&
      (draftBlockStyles = {
        ...draftBlockStyles,
        ...ricosDecorationToCss[decoration.type as $TSFixMeKey<typeof ricosDecorationToCss>](
          decoration
        ),
      });
  });
  return draftBlockStyles;
};

const ricosDecorationToCss = {
  [Decoration_Type.BOLD]: ({ fontWeightValue }: $TSFixMe) => {
    return fontWeightValue ? { 'font-weight': fontWeightValue >= 700 ? 'bold' : 'normal' } : {};
  },
  [Decoration_Type.ITALIC]: ({ italicData }: $TSFixMe) => {
    return typeof italicData !== 'undefined'
      ? { 'font-style': italicData ? 'italic' : 'normal' }
      : {};
  },
  [Decoration_Type.UNDERLINE]: ({ underlineData }: $TSFixMe) => {
    return typeof underlineData !== 'undefined'
      ? {
          'text-decoration': underlineData ? 'underline' : 'none',
        }
      : {};
  },
  [Decoration_Type.FONT_SIZE]: ({ fontSizeData }: $TSFixMe) => {
    return fontSizeData
      ? { 'font-size': fontSizeData.value + (fontSizeData.unit.toLowerCase() || 'px') }
      : {};
  },
  [Decoration_Type.COLOR]: ({ colorData }: $TSFixMe) => {
    const { foreground, background } = colorData;
    const colors: $TSFixMe = {};
    // eslint-disable-next-line dot-notation
    foreground && (colors['color'] = foreground);
    background && (colors['background-color'] = background);
    return colors;
  },
};

const convertNodeStyleToCss = (nodeStyle: $TSFixMe) => {
  const css: $TSFixMe = {};
  nodeStyle.paddingTop && (css['padding-top'] = nodeStyle.paddingTop);
  nodeStyle.paddingBottom && (css['padding-bottom'] = nodeStyle.paddingBottom);
  nodeStyle.lineHeight && (css['line-height'] = nodeStyle.lineHeight);
  return css;
};

const parseDocStyle = (documentStyle: $TSFixMe) => {
  const draftDocStyle: $TSFixMe = {};
  Object.entries(documentStyle).forEach(([header, values]) => {
    if (values) {
      const { decorations = [], nodeStyle, lineHeight } = values as TextNodeStyle;
      draftDocStyle[header] = {
        ...convertDocumentStyleDecorationTypes(decorations),
        ...convertNodeStyleToCss({ ...nodeStyle, lineHeight }),
      };
    }
  });
  return draftDocStyle;
};

export default parseDocStyle;
